// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Gothic+A1&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finisher_wrapper {
    width: 100%;
    padding: 0 62px;

}

.finisher_heading_div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
}

.finisher_heading {
    text-transform: uppercase;
    font-size: 160px;
    font-weight: 1000;
    letter-spacing: 10px;
    background-image: linear-gradient(90deg, #fff 50%, #151515 50%), linear-gradient(45deg, #151615, #151615, #151615, #151615, #151615, #504f4f, #525050, #2d2b2b);
    background-size: 200% 100%, 400% 400%;
    background-position: 100% 0, 0 0;
    background-clip: text, padding-box;
    -webkit-background-clip: text, padding-box;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 2px white;
    animation: one-animation 4s ease-in-out infinite;
    border-bottom: 6px solid #206D23;
    padding: 0 20px;
    margin-bottom: 48px;
}
@keyframes one-animation {
    0% { background-position: 100% 0, 0 0 }
    50% { background-position: 0 0, 0 0 }
    100% { background-position: 100% 0, 0 0 }
}



.finisher_para_div > p{
    margin-bottom: 15px;
    color: #CECECE;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: "Open Sans";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 38.4px; /* 160% */
}










@media screen and (max-width: 1200px) {

    .finisher_wrapper {
        width: 100%;
        padding: 0 62px;
        margin-top: -20px;
    }
    
    .finisher_heading_div {
        width: 100%;
    }
    
    .finisher_heading {
        font-size: 150px;
        font-weight: 1000;
        letter-spacing: 10px;
        border-bottom: 4px solid #206D23;
        padding: 0 20px;
        margin-bottom: 30px;
    }    
    
    .finisher_para_div > p{
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 10px;
    }

}












@media screen and (max-width: 1024px) {

    .finisher_wrapper {
        width: 100%;
        padding: 0 20px;
    }
    
    .finisher_heading_div {
        width: 100%;
    }
    
    .finisher_heading {
        font-size: 140px;
        font-weight: 1000;
        letter-spacing: 10px;
        border-bottom: 4px solid #206D23;
        padding: 0 16px;
        margin-bottom: 30px;
    }    
    
    .finisher_para_div > p{
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 10px;
    }

}











@media screen and (max-width: 800px) {

    .finisher_wrapper {
        width: 100%;
        padding: 0 20px;
    }
    
    .finisher_heading_div {
        width: 100%;
    }
    
    .finisher_heading {
        font-size: 110px;
        font-weight: 1000;
        letter-spacing: 5px;
        border-bottom: 4px solid #206D23;
        padding: 0 20px;
        margin-bottom: 30px;
    }    
    
    .finisher_para_div > p{
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
    }

}














@media screen and (max-width: 600px) {

    .finisher_wrapper {
        width: 100%;
        padding: 0 20px;
    }
    
    .finisher_heading_div {
        width: 100%;
    }
    
    .finisher_heading {
        font-size: 80px;
        font-weight: 1000;
        letter-spacing: 5px;
        border-bottom: 4px solid #206D23;
        padding: 0 16px;
        margin-bottom: 20px;
    }    
    
    .finisher_para_div > p{
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
    }

}















@media screen and (max-width: 450px) {

    .finisher_wrapper {
        width: 100%;
        padding: 0 16px;
    }
    
    .finisher_heading_div {
        width: 100%;
        margin: 0 0 10px 0;
    }
    
    .finisher_heading {
        font-size: 60px;
        font-weight: 1000;
        letter-spacing: 5px;
        border-bottom: 4px solid #206d23;
        padding: 0 16px;
        margin-bottom: 10px;
    }    
    
    .finisher_para_div > p{
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/homePage/finisher/finisher.css"],"names":[],"mappings":"AAIA;IACI,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,+JAA+J;IAC/J,qCAAqC;IACrC,gCAAgC;IAChC,kCAAkC;IAClC,0CAA0C;IAC1C,oCAAoC;IACpC,8BAA8B;IAC9B,gDAAgD;IAChD,gCAAgC;IAChC,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,KAAK,iCAAiC;IACtC,MAAM,8BAA8B;IACpC,OAAO,iCAAiC;AAC5C;;;;AAIA;IACI,mBAAmB;IACnB,cAAc;IACd,6CAA6C;IAC7C,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE,SAAS;AAClC;;;;;;;;;;;AAWA;;IAEI;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,gCAAgC;QAChC,eAAe;QACf,mBAAmB;IACvB;;IAEA;IACA,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ;;;;;;;;;;;;;AAaA;;IAEI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,gCAAgC;QAChC,eAAe;QACf,mBAAmB;IACvB;;IAEA;IACA,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ;;;;;;;;;;;;AAYA;;IAEI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,gCAAgC;QAChC,eAAe;QACf,mBAAmB;IACvB;;IAEA;IACA,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ;;;;;;;;;;;;;;;AAeA;;IAEI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,gCAAgC;QAChC,eAAe;QACf,mBAAmB;IACvB;;IAEA;IACA,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ;;;;;;;;;;;;;;;;AAgBA;;IAEI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,gCAAgC;QAChC,eAAe;QACf,mBAAmB;IACvB;;IAEA;IACA,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB;;AAEJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Gothic+A1&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');\n\n.finisher_wrapper {\n    width: 100%;\n    padding: 0 62px;\n\n}\n\n.finisher_heading_div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 !important;\n}\n\n.finisher_heading {\n    text-transform: uppercase;\n    font-size: 160px;\n    font-weight: 1000;\n    letter-spacing: 10px;\n    background-image: linear-gradient(90deg, #fff 50%, #151515 50%), linear-gradient(45deg, #151615, #151615, #151615, #151615, #151615, #504f4f, #525050, #2d2b2b);\n    background-size: 200% 100%, 400% 400%;\n    background-position: 100% 0, 0 0;\n    background-clip: text, padding-box;\n    -webkit-background-clip: text, padding-box;\n    -webkit-text-fill-color: transparent;\n    -webkit-text-stroke: 2px white;\n    animation: one-animation 4s ease-in-out infinite;\n    border-bottom: 6px solid #206D23;\n    padding: 0 20px;\n    margin-bottom: 48px;\n}\n@keyframes one-animation {\n    0% { background-position: 100% 0, 0 0 }\n    50% { background-position: 0 0, 0 0 }\n    100% { background-position: 100% 0, 0 0 }\n}\n\n\n\n.finisher_para_div > p{\n    margin-bottom: 15px;\n    color: #CECECE;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: \"Open Sans\";\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 38.4px; /* 160% */\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n    .finisher_wrapper {\n        width: 100%;\n        padding: 0 62px;\n        margin-top: -20px;\n    }\n    \n    .finisher_heading_div {\n        width: 100%;\n    }\n    \n    .finisher_heading {\n        font-size: 150px;\n        font-weight: 1000;\n        letter-spacing: 10px;\n        border-bottom: 4px solid #206D23;\n        padding: 0 20px;\n        margin-bottom: 30px;\n    }    \n    \n    .finisher_para_div > p{\n    font-size: 22px;\n    line-height: 28px;\n    margin-bottom: 10px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n    .finisher_wrapper {\n        width: 100%;\n        padding: 0 20px;\n    }\n    \n    .finisher_heading_div {\n        width: 100%;\n    }\n    \n    .finisher_heading {\n        font-size: 140px;\n        font-weight: 1000;\n        letter-spacing: 10px;\n        border-bottom: 4px solid #206D23;\n        padding: 0 16px;\n        margin-bottom: 30px;\n    }    \n    \n    .finisher_para_div > p{\n    font-size: 20px;\n    line-height: 26px;\n    margin-bottom: 10px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n    .finisher_wrapper {\n        width: 100%;\n        padding: 0 20px;\n    }\n    \n    .finisher_heading_div {\n        width: 100%;\n    }\n    \n    .finisher_heading {\n        font-size: 110px;\n        font-weight: 1000;\n        letter-spacing: 5px;\n        border-bottom: 4px solid #206D23;\n        padding: 0 20px;\n        margin-bottom: 30px;\n    }    \n    \n    .finisher_para_div > p{\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 10px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n    .finisher_wrapper {\n        width: 100%;\n        padding: 0 20px;\n    }\n    \n    .finisher_heading_div {\n        width: 100%;\n    }\n    \n    .finisher_heading {\n        font-size: 80px;\n        font-weight: 1000;\n        letter-spacing: 5px;\n        border-bottom: 4px solid #206D23;\n        padding: 0 16px;\n        margin-bottom: 20px;\n    }    \n    \n    .finisher_para_div > p{\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 10px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n    .finisher_wrapper {\n        width: 100%;\n        padding: 0 16px;\n    }\n    \n    .finisher_heading_div {\n        width: 100%;\n        margin: 0 0 10px 0;\n    }\n    \n    .finisher_heading {\n        font-size: 60px;\n        font-weight: 1000;\n        letter-spacing: 5px;\n        border-bottom: 4px solid #206d23;\n        padding: 0 16px;\n        margin-bottom: 10px;\n    }    \n    \n    .finisher_para_div > p{\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 10px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
